import React, { useRef } from 'react';
import Slider from 'react-slick'; // 1. Importar el componente Slider
import TestimonioCard from './TestimoniosCard';

//Importar los estilos CSS de la biblioteca
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


const casosData = [
    {
        id: 1,
        caso: "Hábeas Corpus Correctivo",
        descripcion: [
            "Acción Legal: Se interpuso un Habeas Corpus Correctivo en favor de un cliente que sufría hacinamiento grave (5 personas en una celda para 2).",
            "Argumento Clave: El Dr. Córdoba demostró que esta situación violaba derechos fundamentales y agravaba ilegítimamente la pena.",
            "Éxito Obtenido: El Juez hizo lugar al reclamo y ordenó el traslado inmediato del cliente a una celda digna." 
        ],
        
        urlPdf: "/images/hc_ejec_3.pdf" // Asegúrate de que este es el nombre en tu carpeta /public/images/
    },
    {
        id: 2,
        caso: "Hábeas Corpus (Juzgado Federal)",
        descripcion: [
            "Acción Legal: Se accionó ante el Juzgado Federal N° 3 por un agravamiento de las condiciones de detención. El cliente dormía en el piso y padecía una sobrepoblación del 100% en su celda (4 personas en un espacio para 2)."
            ,
            "Argumento Clave: La defensa, a cargo del Dr. Córdoba, planteó que esta situación vejatoria violaba garantías constitucionales y tratados internacionales (citando las Reglas Mandela).",
            "Éxito Obtenido: El Juez Federal hizo lugar al planteo. Se consiguió una orden inmediata para la entrega de un colchón y, en la sentencia, se ordenó el realojamiento del cliente para cumplir con la capacidad máxima de 2 personas por celda."
        ],
        urlPdf: "/images/fj3_hc_hacinamiento_ep1.pdf" 
    },/*
    {
        id: 3,
        caso: "Prisión domiciliaria e interés superior del niño",
        descripcion: [
            "Planteo: Se solicitó prisión domiciliaria para una imputada, invocando el interés superior del niño (Convención sobre los Derechos del Niño, art. 75 inc. 22 CN)."
            ,
            "La ley limita el beneficio a hijos menores de 5 años; los hijos tenían 6 y 10.",
            "El Tribunal Oral Federal de Córdoba priorizó el principio constitucional y mantuvo la domiciliaria.El fallo reafirma la supremacía constitucional y la primacía de los principios sobre la literalidad legal."
        ],
        urlPdf: "/images/caso3_fallo_domiciliario.pdf" 
    }, */
    {
        id: 4,
        caso: "Control Jurisdiccional Favorable (Delitos Complejos-Asociación Ilícita)",
        descripcion: [
            "Acción Legal: El abogado Gastón Córdoba presentó un control jurisdiccional, solicitando el cese de la prisión preventiva dictada en una causa por asociación ilícita.",
            "Argumento Clave: Se demostró que la continuidad de la medida cautelar resultaba improcedente y desproporcionada, al no subsistir con entidad suficiente los riesgos procesales exigidos para su mantenimiento.",
            "Éxito Obtenido: El Tribunal hizo lugar al planteo y ordenó la libertad del imputado, imponiendo reglas de conducta y caución para garantizar su sujeción al proceso."
        ],
        urlPdf: "/images/caso4_control_juridiccional_favorable.pdf" 
    },
    {
        id: 5,
        caso: "Libertad Condicional Concedida",
        descripcion: [
            "Acción Legal: El abogado Gastón Córdoba presentó el pedido de Libertad Condicional, solicitando el otorgamiento del beneficio conforme a los requisitos legales aplicables.",
            "Argumento Clave: Se acreditó un pronóstico favorable de reinserción, con informes técnicos positivos, adecuada conducta penitenciaria y un plan de vida concreto en libertad.",
            "Éxito Obtenido: El Tribunal concedió la Libertad Condicional, permitiendo que el cliente recupere su libertad varios meses antes del cumplimiento total de la condena, bajo reglas de conducta y seguimiento extramuros."
        ],
        urlPdf: "/images/caso5_libertad_condicional_concedida.pdf"
    }

    
    // ... más casos
];

const TestimoniosPage = () => {
    const sliderRef = useRef(null);
    // 4. Configuración del carrusel
    const settings = {
        dots: false,           // Muestra los puntos de navegación
        infinite: true,       // El carrusel es infinito (vuelve al principio)
        speed: 500,           // Velocidad de la transición en ms
        slidesToShow: 1,      // Muestra 1 slide a la vez
        slidesToScroll: 1,    // Avanza de a 1 slide
        adaptiveHeight: true, // Se ajusta a la altura del slide actual
        lazyLoad: 'ondemand', // Carga el PDF solo cuando el slide es visible
        arrows: false,          // Muestra las flechas de Siguiente/Anterior
        swipe: false,       // Deshabilita el swipe general
        draggable: false,   // Deshabilita arrastrar con el mouse
        touchMove: false
    };
    const irSiguiente = () => {
        sliderRef.current.slickNext();
    };

    const irAnterior = () => {
        sliderRef.current.slickPrev();
    };

    return (
        // 5. Contenedor principal para el carrusel
        <section className="testimonios-seccion">
           {/* 5. Asigna la ref al Slider */}
                <Slider ref={sliderRef} {...settings}>
                    {casosData.map(caso => (
                        <div key={caso.id}> 
                            <TestimonioCard 
                                key={caso.id} 
                                caso={caso.caso} 
                                descripcion={caso.descripcion} 
                                urlPdf={caso.urlPdf}      
                            />
                        </div>
                    ))}
                </Slider>
            {/* 6. Agrega tus botones de navegación personalizados */}
                <div className="custom-nav-buttons">
                    <button className="custom-nav-btn" onClick={irAnterior}>
                        &larr; Caso Anterior
                    </button>
                    <button className="custom-nav-btn" onClick={irSiguiente}>
                        Siguiente Caso &rarr;
                    </button>
                </div>
            {/* 6. Envolvemos el Slider en un div para centrarlo y darle márgenes */}
            
        </section>
    );
};

export default TestimoniosPage;